import React from "react";
import "./expenditure.css";
import Header from "../../components/header/Header";
// import toast from "react-hot-toast";

const Expenditure = () => {

	return (
		<div className="action__page">
			<Header />
			<div className="expenditure__page__heading">RECURRENT EXPENDITURE DESK</div>
			<div className="expenditure__initiator__review">
				<div className="expenditure__card-wrapper">
					<div className="expenditure__card-container">
						<div className="expenditure__card--header">CLASSIFICATION CODE</div>
						<div className="expenditure__card">
							<div className="expenditure__card-item">
								<button className="expenditure__card-submit__button">
									Generate Code
								</button>
							</div>
						</div>
					</div>

					<div className="expenditure__card-container">
						<div className="expenditure__card--header">ITEM OF EXPENDITURE</div>
						<div className="expenditure__card">
							<div className="expenditure__card-item">
								<textarea placeholder="input text here"></textarea>
							</div>
						</div>
					</div>

					<div className="expenditure__card-container">
						<div className="expenditure__card--header">PAYEE</div>
						<div className="expenditure__card">
							<div className="expenditure__card-item">
								<textarea placeholder="input text here"></textarea>
							</div>
						</div>
					</div>

					<div className="expenditure__card-container">
						<div className="expenditure__card--header">PROVISIONS</div>
						<div className="expenditure__card">
							<form>
								<label htmlFor="apd-provision">APPROVED PROVISION:</label>
								<input
									type="text"
									id="apd-provision"
									name="apd-provision"
									placeholder="input text here"
								/>

								<label htmlFor="rev-provision">REVISED PROVISION:</label>
								<input
									type="text"
									id="rev-provision"
									name="rev-provision"
									placeholder="input text here"
								/>
							</form>
						</div>
					</div>

					<div className="expenditure__card-container">
						<div className="expenditure__card--header">
							EXPENDITURE & CURRENT BALANCE
						</div>
						<div className="expenditure__card">
							<form>
								<label htmlFor="apd-provision">EXPENDITURE TO DATE:</label>
								<input
									type="text"
									id="apd-provision"
									name="apd-provision"
									placeholder="input text here"
								/>

								<label htmlFor="rev-provision">CURRENT BALANCE:</label>
								<input
									type="text"
									id="rev-provision"
									name="rev-provision"
									placeholder="input text here"
								/>
							</form>
						</div>
					</div>

					<div className="expenditure__card-container">
						<div className="expenditure__card--header">PRESENT REQUISITION</div>
						<div className="expenditure__card">
							<div className="expenditure__card-item">
								<textarea placeholder="input text here"></textarea>
							</div>
						</div>
					</div>

					<div className="expenditure__card-container">
						<div className="expenditure__card--header">BALANCE CARRIED FORWARD</div>
						<div className="expenditure__card">
							<div className="expenditure__card-item">
								<textarea placeholder="input text here"></textarea>
							</div>
						</div>
					</div>

					<div className="expenditure__card-container">
						<div className="expenditure__card--header">STATE CODE</div>
						<div className="expenditure__card">
							<div className="expenditure__card-item">
								<button className="expenditure__card-submit__button">
									Generate Code
								</button>
							</div>
						</div>
					</div>
					<p className="expenditure__note-info">
						N.B. KINDLY REVIEW BEFORE APPROVING
					</p>
				</div>
				<div className="action-btns">
					<button>REJECT</button>
					<button>APPROVE</button>
				</div>
				<p className="expenditure__initiator">PREPARED BY: EBUKA EZE UB48959-09</p>{" "}
				<p className="expenditure__reviewer">
					TO BE REVIEWED BY: ABDUL SADIQ UB689
				</p>
			</div>
		</div>
	);
};

export default Expenditure;
